import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
import { SketchPicker } from 'react-color';
import config from 'src/config';

let aliases = [['personalsbook.com', 'saferpersonals.com']];

function haveAlias(link) {
  let result = false;
  aliases.forEach((arr) => {
    arr.forEach((domain, d) => {
      let index = link.indexOf(domain);
      if (index !== -1 && arr.length > 1) {
        result = { arr, index: d };
      }
    });
  });
  return result;
}

class Component extends React.Component {
  state = {
    colorPicker: false,
    link: ''
  };

  changeColor = (color) => {
    this.setState({
      colorPicker: color,
      color: color.hex.replace('#', '')
    });
  };

  changeDomain = (link) => {
    let { arr, index } = haveAlias(this.state.link || link.link);
    let nextIndex = 0;
    if (arr.length - 1 > index) nextIndex = index + 1;
    this.setState({
      link: link.link.replace(arr[index], arr[nextIndex])
    });
  };

  render() {
    let { user, openModal, onCopy, copied, link } = this.props;

    link.link = link.link.replace('http://', 'https://');
    if (link.link.indexOf('?') == -1) {
      link.link += '?';
    } else if (link.link[link.link.length - 1] != '&' && link.link[link.link.length - 1] != '?') {
      link.link += '&';
    }

    var addon =
      user.role_id == 0 ? 'wid=' + user.owner_wid + '&subaffiliate=' + user.aid : 'wid=' + user.aid;

    if (this.state.color || link.color_bb) {
      addon += '&color_bb=' + (this.state.color || link.color_bb);
    }

    let fullLink = (this.state.link || link.link) + addon;

    var redirWids = link.redirect_wids;
    var exclusiveWids = link.wids;

    let widLists = this.props.listApiState.data && this.props.listApiState.data.items;
    if (widLists && widLists.length > 0) {
      widLists.map((list) => {
        if (link.redirect_list_id > 0) {
          if (list.id == link.redirect_list_id) redirWids = list.name; // + ' (' + list.wids + ')';
        }
        if (link.exclusive_list_id > 0) {
          if (list.id == link.exclusive_list_id) exclusiveWids = list.name; // + ' (' + list.wids + ')';
        }
      });
    }

    return (
      <div key={link.link_id + '_' + link.link} class='pl-3 pr-3'>
        <div class={'landing row box mt-1 ' + (link.hidden == 1 ? 'link-hidden' : '')}>
          <div class={'left-landing col-3 p-2 text-right'}>
            <a href={fullLink} target='_blank'>
              <img class='link-preview' src={'//cashplane.net/uploads/links/' + link.image} />
            </a>
            {this.state.color && (
              <div style={{ color: '#' + this.state.color, textAlign: 'left' }}>Color updated</div>
            )}
          </div>
          <div class='right-landing col-9 p-2'>
            {link.exclusive && <span class='pull-right link-exclusive-label'>exclusive</span>}
            <p>{link.link_name}</p>
            <CopyToClipboard text={fullLink} onCopy={() => onCopy(fullLink)}>
              <button class='btn primary link-copy'>
                {copied == fullLink ? 'Copied' : 'Copy'}
              </button>
            </CopyToClipboard>
            <pre class='p-2 mb-0'>{fullLink}</pre>
            {user.role_id >= 3 && (
              <div>
                {exclusiveWids && (
                  <div style={{ wordBreak: 'break-all' }}>only wids: {exclusiveWids}</div>
                )}
                {redirWids && (
                  <div style={{ wordBreak: 'break-all' }}>redirect wids: {redirWids}</div>
                )}
                {link.redirect_to > 0 && (
                  <div style={{ wordBreak: 'break-all' }}>redirect link: {link.redirect_to}</div>
                )}
                <button
                  class='btn primary pull-right link-edit mt-2'
                  onClick={(e) => openModal(e, link, 'edit')}
                >
                  edit
                </button>
              </div>
            )}
            {link.images > 0 && (
              <button
                class='btn primary pull-left link-edit mt-2'
                onClick={(e) => openModal(e, link, 'images')}
              >
                edit images
              </button>
            )}
            {link.editable == 1 && (
              <button
                class='btn primary pull-left link-edit mt-2'
                onClick={(e) => openModal(e, link, 'editor')}
              >
                edit landing
              </button>
            )}
            {(user.role_id >= 3 || user.autologin) && (
              <Link
                class='btn primary pull-left link-edit mt-2 ml-2'
                to={config.basePath + '/link/' + link.link_id + '/stats'}
              >
                Stats
              </Link>
            )}
            {link.color_bb != '' && !this.state.colorPicker && (
              <button
                class='btn primary pull-left link-edit m-2'
                onClick={(e) =>
                  this.setState({
                    colorPicker: this.state.colorPicker ? false : '#' + link.color_bb
                  })
                }
              >
                Edit color
              </button>
            )}
            {link.color_bb != '' && this.state.colorPicker && (
              <a
                class='btn primary pull-left link-edit m-2'
                target='_blank'
                href={fullLink}
                style={{ color: '#fff' }}
                onClick={(e) =>
                  this.setState({
                    colorPicker: this.state.colorPicker ? false : '#' + link.color_bb
                  })
                }
              >
                Get link
              </a>
            )}
            {this.state.colorPicker && (
              <SketchPicker color={this.state.colorPicker} onChange={this.changeColor} />
            )}
            {!!haveAlias(link.link) && (
              <button
                class='btn primary pull-left link-edit m-2'
                onClick={(e) => this.changeDomain(link)}
              >
                Change domain
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    return {
      listApiState: state.api['affLists_load'] || state.api.initial,
      apiState: state.api['links_available'] || state.api.initial,
      saveApiState: state.api['links_save'] || state.api.initial,
      removeApiState: state.api['links_remove'] || state.api.initial,
      state: state.state['links_available'] || state.state.initial,
      user: state.session.user
    };
  },
  { api, setState: setState('links_available') }
)(Component);
